import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hometwo-banner',
  templateUrl: './hometwo-banner.component.html',
  styleUrls: ['./hometwo-banner.component.scss']
})
export class HometwoBannerComponent {
  @Input() data: any;
  @Input() spotlightArticle: any;

  constructor(public router: Router) {}

  // Méthodes utilitaires
  getPublisher(article: any) {
    if (article && article.attributes && article.attributes.publisher) {
      return article.attributes.publisher;
    }
    return '';
  }

  getCategory(article: any) {
    if (article.attributes?.category?.data === null) {
      return "";
    }
    return article.attributes.category?.data?.attributes;
  }

  getImage(article: any) {
    const url = article.attributes?.image.data?.attributes.url || '';
    return url.replace('/upload/', '/upload/f_auto,q_auto/');
  }

  // Méthodes pour la gestion des images
  onImageLoad(event: any): void {
    event.target.classList.add('loaded');
  }

  onImageError(event: any): void {
    event.target.src = '/assets/images/placeholder.jpg'; // Remplacez par votre image de fallback
    event.target.classList.add('error');
  }
}